import * as Yup from "yup"
import TranslationData from "components/Form/FormTemplate/formtemplate.interface";

export const getValidation = (datatype: number, optional?: boolean, label?: string, t?: any, labelKey?: string, translationData?: TranslationData) => {
  const prefix = translationData?.formTypeKey || "deviation"

  const validationRules = {
    0: optional
      ? Yup.string().nullable()
      : Yup.string()
        .nullable()
        .required(
          t(`${prefix}.${labelKey}`, { defaultValue: label }) + " " +
          `${t("global.is_required", { defaultValue: "is required" })}`
        ),
    1: optional
      ? Yup.number().nullable().typeError(
        t(`${prefix}.${labelKey}`, { defaultValue: label }) + " " +
        `${t("global.must_be_a_number", { defaultValue: "Must be a number" })}`)
      : Yup.number()
        .nullable()
        .typeError(t(`${prefix}.${labelKey}`, { defaultValue: label }) + " " +
          `${t("global.must_be_a_number", { defaultValue: "Must be a number" })}`)
        .required(t(`${prefix}.${labelKey}`, { defaultValue: label }) + " " +
          `${t("global.is_required", { defaultValue: "is required" })}`),
    2: Yup.boolean().nullable().typeError(`${label} must be a boolean`),
    3: optional
      ? Yup.date().nullable().typeError(t(`${prefix}.${labelKey}`, { defaultValue: label }) + " " +
        `${t("global.must_be_a_date", { defaultValue: "Must be a date" })}`)
      : Yup.date()
        .nullable()
        .typeError(t(`${prefix}.${labelKey}`, { defaultValue: label }) + " " +
          `${t("global.must_be_a_date", { defaultValue: "Must be a date" })}`)
        .required(t(`${prefix}.${labelKey}`, { defaultValue: label }) + " " +
          `${t("global.is_required", { defaultValue: "is required" })}`),
    4: optional
      ? Yup.date().nullable().typeError(t(`${prefix}.${labelKey}`, { defaultValue: label }) + " " +
        `${t("global.must_be_a_date", { defaultValue: "Must be a date" })}`)
      : Yup.date()
        .nullable()
        .typeError(t(`${prefix}.${labelKey}`, { defaultValue: label }) + " " +
          `${t("global.must_be_a_date", { defaultValue: "Must be a date" })}`)
        .required(t(`${prefix}.${labelKey}`, { defaultValue: label }) + " " +
          `${t("global.is_required", { defaultValue: "is required" })}`),
    5: optional ? Yup.string().nullable() : Yup.string().nullable().required(t(`${prefix}.${labelKey}`, { defaultValue: label }) + " " +
      `${t("global.is_required", { defaultValue: "is required" })}`),
    6: optional ? Yup.string().nullable() : Yup.string().required(t(`${prefix}.${labelKey}`, { defaultValue: label }) + " " +
      `${t("global.is_required", { defaultValue: "is required" })}`)
  } as any

  return validationRules[datatype] || null
}
